import script from "./OrgUsageDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgUsageDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OrgUsageDashboard.vue?vue&type=style&index=0&id=1900a0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1900a0ea"]])

export default __exports__